// extracted by mini-css-extract-plugin
export default {"uploadFile":"style_uploadFile__nRGDb","text":"style_text__DW9-+","droptext":"style_droptext__PnOC+"};